import React from 'react'
import useStyles from './utils/comparatoreStyle';

import { CardActionArea, CardActions, IconButton, Typography, Chip, Hidden } from '@mui/material';

import { CheckCircleOutline, ExpandLess, ExpandMore } from '@mui/icons-material'
import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';
import { addizionaleInUso } from './utils/funzioni';
import { useContext } from 'react';
import StatoComparatoreContext from './contexts/StatoComparatore'
import { Avatar } from '@mui/material';
import { Stack } from '@mui/material';
import { Tooltip } from '@mui/material';
import { Card } from '@mui/material';
import AvatarAddizionale from './AvatarAddizionale';
import { AvatarGroup } from '@mui/material';

const {logger} = useBSSLogger();


const HeaderAddizionali = ({listaaddizionali, preventivo}) => {

    const classes = useStyles();
    const identificativo = preventivo.price.id;

    const {expanded, setExpanded, methods, addizionaliById, categoriaById} = useContext(StatoComparatoreContext);

    const toggleExpanded = () => {
        const actuallyExpanded = (expanded?.[identificativo] ?? false)
        logger.debug("aggiorno stato collapse per", identificativo, expanded, actuallyExpanded)

        const newState = {
            ...expanded,
            [identificativo]: !actuallyExpanded
        }
        setExpanded(newState);
    }

    const espanso = expanded[identificativo];
    
    return (
        <>
            <CardActionArea>
                <CardActions onClick={e => toggleExpanded()} className={classes.root}>
                    <div className={classes.content}>                        
                        <Stack direction="row" spacing={1} sx={{pl: 1.2}}> 
                            <AvatarGroup  max={5} total={listaaddizionali?.length ?? 0}>
                                {listaaddizionali
                                    .sort((a, b) => {
                                        /**@type {String} */
                                        const labela = categoriaById?.[a?.id]?.codice ?? (a?.nome?.testo) ?? "";

                                        /**@type {String} */
                                        const labelb = categoriaById?.[b?.id]?.codice ?? (b?.nome?.testo) ?? "";
                                        
                                        return labela.localeCompare(labelb);
                                    })
                                    .map((addizionale, indiceAddizionale) => {

                                        return <AvatarAddizionale key={addizionale.id} 
                                            {...{addizionale, preventivo}} 
                                        />
                                    })
                                }                         
                            </AvatarGroup>

                        </Stack>
                    </div>
                    
                    <IconButton  size="small" color="primary">
                        {espanso ? <ExpandLess /> : <ExpandMore />}
                    </IconButton>
                </CardActions>
            </CardActionArea>
        </>
    )
}

export default HeaderAddizionali